<div class="store-supplier-container">
  <span>Store:</span>
  <primeng-multiselect
    ngClass="store-select"
    [setUrl]="'store/lookup'"
    [isFilterOnly]="true"
    [isSingle]="false"
    [baseMaxResults]="1000"
    [pageSize]="50"
    [allowMultipleFromSearch]="true"
    placeholder="Search stores (name, code, location)..."
    (onChange)="storeSelectChange($event)"
  >
  </primeng-multiselect>
  <span class="supplier-label">Supplier:</span>
  <primeng-multiselect
    ngClass="supplier-select"
    [setUrl]="'global-supplier/lookup'"
    [isFilterOnly]="true"
    [isSingle]="false"
    [baseMaxResults]="1000"
    [pageSize]="50"
    [allowMultipleFromSearch]="true"
    placeholder="Search suppliers (name, code, contact)..."
    (onChange)="supplierSelectChange($event)"
  >
  </primeng-multiselect>
  <button
    pButton
    type="button"
    icon="pi pi-search"
    class="ui-button-info"
    (click)="onSearchClick()"
    label="Search"
  ></button>
</div>
